import { Button, Link, Typography } from "@material-ui/core";
import React from "react";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  img: {
    width: theme.spacing(4),
    flexShrink: 0
  },
  root: {
    display: "flex",
    backgroundColor: "#f7f7f7",
    border: "1px solid #ddd",
    alignItems: "flex-start",
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3)
  },
  title: {
    lineHeight: "1.25rem",
    fontWeight: 500,
    marginBottom: theme.spacing(1)
  },
  description: {},
  content: {
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(6)
  },
  btn: {
    fontSize: "0.875rem",
    textTransform: "none",
    marginTop: theme.spacing(2)
  },
  link: {
    whiteSpace: "nowrap",
    fontSize: "15px",
    lineHeight: "16px",
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    textDecoration: "none",
    visibility: 'hidden',
    "& .MuiSvgIcon-root": {
      marginLeft: theme.spacing(0.5)
    }
  }
}));

export default function AppCard({
  appLogo,
  title,
  description,
  app,
  handleConnect
}) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <img className={classes.img} src={appLogo} alt="" />
      <div className={classes.content}>
        <Typography className={classes.title}>{title}</Typography>
        <Typography
          className={classes.description}
          color="secondary"
          variant="body2"
        >
          {description}
        </Typography>
        <Button
          className={classes.btn}
          variant="contained"
          color="primary"
          onClick={() => handleConnect(title, app)}
          disableElevation
        >
          {!app ? "Connect" : "Disconnect"}
        </Button>
      </div>
      <Link className={classes.link}>
        Read more <ArrowForwardIcon color="primary" fontSize="small" />
      </Link>
    </div>
  );
}
